import { ContactUs, Homepage, Pricing, SectorsPage,FreemiumCRS } from "./pages";
import AgreementPage from "./pages/agreement";
import Blogsindex from "./pages/blogs";
import HelpPage from "./pages/help";
import PaymentSuccess from "./pages/paymentmodal/paymentSuccess";
import SuccessRedirectAppPage from "./pages/paymentmodal/successMessagePage";
import SpecificationDetailPage from "./pages/specification-details";
import SectorDetailPage from "./pages/specification/SectorDetailPage";

interface RouteProps {
  path: string;
  element: any;
  exact?: boolean;
}

const nonauthRoutes: Array<RouteProps> = [
  { path: "/pricing", element: <Pricing /> },
  { path: "/blogs", element: <Blogsindex /> },
  { path: "/blogs/freemium-car-rental-software", element: <FreemiumCRS /> },
  { path: "/contactus", element: <ContactUs /> },
  {
    path: "/solutions",
    element: <SectorsPage />,
  },
  {
    path: "/solutions/:sectorseo",
    element: <SectorDetailPage />,
  },
  {
    path: "/features",
    element: <SpecificationDetailPage />,
  },
  {
    path: "/features/:moduleseo",
    element: <SpecificationDetailPage />,
  },
  {
    path: "/paymentsuccess",
    element: <PaymentSuccess />,
  },
  {
    path: "/payment-success/:id",
    element: <SuccessRedirectAppPage />,
  },
  // {
  //   path: "/specification/:sectorseo/:webmoduleseo",
  //   element: <SpecificationDetails />,
  // },
  { path: "/agreements/:id", element: <AgreementPage /> },
  { path: "/help", element: <HelpPage /> },
  { path: "/", element: <Homepage /> },

  // { path: "/pricing", element: <Pricing /> },
  // { path: "/contactus", element: <ContactUs /> },
  // { path: "/specification", element: <Specification /> },
  // { path: "/agreements/:id", element: <AgreementPage /> },
  // { path: "/help", element: <HelpPage /> },
  { path: "/", element: <Homepage /> },
];

const authRoutes: Array<RouteProps> = [];

export { nonauthRoutes, authRoutes };
